appSocial.component('compareIndicator', {
    templateUrl: 'widgets/leader-compare/components/compare-indicator/CompareIndicatorComponent.html',
    controller: class CompareIndicatorComponent {
        constructor($scope,
                    SocialUtils,
                    SocialLocaleService,
                    LeadersCompareService) {
            this.translation = SocialLocaleService.translation;
            this.utils = SocialUtils;
            /**
             * @type {LeadersCompareService}
             */
            this.compareService = LeadersCompareService;

        }

        $onInit() {
            this.selectedTranslation = this.utils.renderTranslation(this.translation.selected, {
                num: this.compareService.getCompareLimit()
            })
        }

        $onChanges(changes) {
        }

        $onDestroy() {
        }

        stopComparing() {
            this.compareService.disableSelection();
        }
    }
});
